import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from 'pages/Home';
import NotFound from 'pages/NotFound';
import { ProtectedRoute } from 'components';

import AppLayout from './AppLayout';
import AttestationValidationEnqueteFonciere from 'pages/Delimitations/AttestationValidationEnqueteFonciere';
import PageAttestationValidationEnqueteFonciere from 'pages/Delimitations/AttestationValidationEnqueteFonciere/page';
const AdminHomePage = React.lazy(() => import('pages/Admin/AdminHomePage'));

// Dashboard Presfor Routes
const AdminPresforPage = React.lazy(() => import('pages/Admin/AdminPresforPage'));
const ContractPresfor = React.lazy(() => import('pages/Admin/AdminPresforPage'));
const CertificatPresfor = React.lazy(() => import('pages/Admin/AdminPresforPage'));
const SettingPresfor = React.lazy(() => import('pages/Admin/AdminPresforPage'));
const NotificationPresfor = React.lazy(() => import('pages/Admin/AdminPresforPage'));
const CorbeillePresfor = React.lazy(() => import('pages/Admin/AdminPresforPage'));
const OtaPresfor = React.lazy(() => import('pages/Admin/AdminPresforPage'));
const UserPresfor = React.lazy(() => import('pages/Admin/AdminPresforPage'));
const Dtv = React.lazy(() => import('pages/Admin/AdminPresforPage'));
const IsfComplementaire = React.lazy(() => import('pages/Admin/AdminPresforPage'));
const IsfPrealable = React.lazy(() => import('pages/Admin/AdminPresforPage'));





const User = React.lazy(() => import('pages/Admin/AdminHomePage'));
const ErrorBoundary = React.lazy(() => import('components/Error'));

const Resumecontrat = React.lazy(() => import('pages/Contrats/Resumecontrat'));
const AddCF = React.lazy(() => import('pages/Certifications/AddCF'));
const EditCF = React.lazy(() => import('pages/Certifications/EditCF'));
const AddFicheIdentification = React.lazy(() =>
  import('pages/Certifications/CF2')
);
const AddCFInfo = React.lazy(() => import('pages/Certifications/AddCFInfo'));

const PSFCPAMOFORlivrablescf = React.lazy(() =>
  import('pages/Certifications/PSFCPAMOFORlivrablescf')
);

const PSFCPAMOFORLivrablesCloture = React.lazy(() =>
  import('pages/Clotures/PSFCPAMOFORLivrablesCloture')
);

const ConsolidationAttestationFormationAEFJ = React.lazy(() =>
  import('pages/ConsolidationDispositifs/AttestationFormationAEFJ')
);

const ConsolidationAttestationFormationAEFC = React.lazy(() =>
  import('pages/ConsolidationDispositifs/AttestationFormationAEFC')
);

const PSFCPAMOFORLivrablesConsolidation = React.lazy(() =>
  import('pages/ConsolidationDispositifs/PSFCPAMOFORLivrablesConsolidation')
);

const PSFCPAMOFORLivrablesConsolidationDroits = React.lazy(() =>
  import('pages/ConsolidationDroits/PSFCPAMOFORLivrablesConsolidationDroits')
);
const PSFCPAMOFORlivrablesIngenieurieSociaux = React.lazy(() =>
  import(
    'pages/IngenieurieSociauxFonciere/PSFCPAMOFORlivrablesIngenieurieSociaux'
  )
);

const PSFCPAMOFORlivrablesIngenieurieSociauxSousPrefecture = React.lazy(() =>
  import(
    'pages/IngenieurieSociauxFonciere/ISFPrealable/SousPrefecture/PSFCPAMOFORlivrablesIngenieurieSociauxSousPrefecture'
  )
);


const PSFCPAMOFORLivrablesSensibilisation = React.lazy(() =>
  import('pages/Sensibilisations/PSFCPAMOFORLivrablesSensibilisation')
);

const PSFCPAMOFORLivrablesDelimitation = React.lazy(() =>
  import('pages/Delimitations/PSFCPAMOFORLivrablesDelimitation')
);

const PSFCPAMOFORlivrablesIngenieurieSociauxDecisionCreation = React.lazy(() =>
  import(
    'pages/IngenieurieSociauxFonciere/ISFPrealable/Diagnostic-cvgfr/Decision-creation-cvgfr/index'
  )
);

const PSFCPRESFORISFResolutionsdesReunionsCSPISF = React.lazy(() =>
  import(
    'pages/IngenieurieSociauxFonciere/ISFPrealable/DecisionSousPrefectorale/ResolutionsdesReunionsCSPISF'
  )
);

const PSFCPRESFORISFDesignationActivitesDialogueSocial = React.lazy(() =>
  import(
    'pages/IngenieurieSociauxFonciere/ISFPrealable/DecisionSousPrefectorale/DesignationActivitesDialogueSocial'
  )
);

const PSFCPAMOFORlivrablesIngenieurieSociauxProcesVerbal = React.lazy(() =>
  import(
    'pages/IngenieurieSociauxFonciere/ISFPrealable/Diagnostic-cvgfr/Proces-verbal-de-constitution/index'
  )
);

// const PSFCPAMOFORlivrablesIngenieurieSociauxDecisionSousPrefectoral = React.lazy(() =>
//   import('pages/IngenieurieSociauxFonciere/DecisionSousPrefectorale/index')
// );

const PSFCPAMOFORlivrablesIngenieurieSociauxDiagnosticCvgfrLivrable =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/Diagnostic-cvgfr/Livrable-cvgfr/index'
    )
  );

const PSFCPAMOFORlivrablesIngenieurieSociauxAttestationFormationCvgfr =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/FormationMembreCVGFR/AttestationFormationCvgfr/index'
    )
  );
const PSFCPAMOFORLivrablespresforResolutionReunionsCspisf = React.lazy(() =>
  import(
    'pages/IngenieurieSociauxFonciere/ISFPrealable/ReunionPeriodriqueComiteSousPrefectoralIgnierieSocioFonciere/PresforResolutionReunionsCspisf/index'
  )
);
const PSFCPAMOFORlivrablespresforProceduresEtablissementEtatCivil = React.lazy(
  () =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/PresforProceduresEtablissementEtatCivil/index'
    )
);
const PSFCPAMOFORlivrablespresforProceduresEtablissementEtatCivilCreate =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/PresforProceduresEtablissementEtatCivil/create/index'
    )
  );
const PSFCPAMOFORlivrablespresforEnqueteOrganisationSocioFonciere = React.lazy(
  () =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/EnqueteOrganisationSocioFonciere/index'
    )
);

const PSFCPAMOFORlivrablesIngenieurieSociauxInformationSensibilisation = React.lazy(() =>
  import(
    'pages/IngenieurieSociauxFonciere/ISFComplementaire/InformationSensibilisation/index'
  )
);

// const Addlettretransmission = React.lazy(() =>
//   import('pages/')
// );
const PSFCPAMOFORENQCF = React.lazy(() =>
  import('pages/Certifications/PSFCPAMOFORENQCF')
);
const DemandeEnqCF = React.lazy(() =>
  import('pages/Certifications/CF1/DemandeEnqCF')
);
const InfoOPTCF = React.lazy(() =>
  import('pages/Certifications/CF1/InfoOPTCF')
);
const PUB = React.lazy(() => import('pages/Certifications/PUB'));
const AddOuverturePub = React.lazy(() =>
  import('pages/Certifications/CF20/AddOuverturePub')
);
const AddEnqueteOuverturePub = React.lazy(() =>
  import('pages/Certifications/CF20/AddEnqueteOuverturePub')
);
const AddAnnexesOuverturePub = React.lazy(() =>
  import('pages/Certifications/CF20/AddAnnexesOuverturePub')
);
const AddCf19 = React.lazy(() => import('pages/Certifications/CF19/AddCf19'));
const CF20 = React.lazy(() => import('pages/Certifications/CF20'));
const AddPVPub = React.lazy(() => import('pages/Certifications/CF9/AddPVPub'));
const AddAnnexesPVPub = React.lazy(() =>
  import('pages/Certifications/CF9/AddAnnexesPVPub')
);
const CF9 = React.lazy(() => import('pages/Certifications/CF9'));
const CF8 = React.lazy(() => import('pages/Certifications/CF8'));
const AddAnnoncePub = React.lazy(() =>
  import('pages/Certifications/CF8/AddAnnoncePub')
);
const AddAnnexesAnnoncePub = React.lazy(() =>
  import('pages/Certifications/CF8/AddAnnexesAnnoncePub')
);
const FicheLitigesCF = React.lazy(() =>
  import('pages/Certifications/CF3/FicheLitigesCF')
);
const ListeDesServitudes = React.lazy(() =>
  import('pages/Certifications/CF3/ListeDesServitudes')
);
const EtatDesDroitsDeProp = React.lazy(() =>
  import('pages/Certifications/CF3/EtatDesDroitsDeProp')
);
const ListeDetenteursDeDroitsCF = React.lazy(() =>
  import('pages/Certifications/CF3/ListeDetenteursDeDroitsCF')
);
const PVRDCTemplate = React.lazy(() =>
  import('pages/Certifications/Templates/PVRDC')
);
const ListeDesAyantsDroitsCF = React.lazy(() =>
  import('pages/Certifications/CF3/ListeDesAyantsDroitsCF')
);
const GestionnaireCF = React.lazy(() =>
  import('pages/Certifications/CF3/DesignationGestionnaireCF/GestionnaireCF')
);

const CF19 = React.lazy(() => import('pages/Certifications/CF19'));
const CF11 = React.lazy(() => import('pages/Certifications/CF11'));
const AddAnnexesValidation = React.lazy(() =>
  import('pages/Certifications/CF11/AddAnnexesValidation')
);
const AddValidation = React.lazy(() =>
  import('pages/Certifications/CF11/AddValidation')
);
const CF10 = React.lazy(() => import('pages/Certifications/CF10'));

const UpdateGestionnaireCF = React.lazy(() =>
  import(
    'pages/Certifications/CF3/DesignationGestionnaireCF/GestionnaireCF/update'
  )
);

const AddAnnexesCECPDC = React.lazy(() =>
  import('pages/Certifications/CF10/AddAnnexesCECPDC')
);
const AddCECPDC = React.lazy(() =>
  import('pages/Certifications/CF10/AddCECPDC')
);
const SignatairesDesignationGestionnaire = React.lazy(() =>
  import(
    'pages/Certifications/CF3/DesignationGestionnaireCF/SignatairesDesignationGestionnaire'
  )
);
const CF4 = React.lazy(() => import('pages/Certifications/CF4'));
const AddAnnexesPVCL = React.lazy(() =>
  import('pages/Certifications/CF4/AddAnnexesPVCL')
);
const AddDemandePVCLAnnexes = React.lazy(() =>
  import('pages/Certifications/CF4/AddDemandePVCL/pvcl-annexe')
);
const AddPVCL = React.lazy(() => import('pages/Certifications/CF4/AddPVCL'));
const AddDemandePVCL = React.lazy(() => import('pages/Certifications/CF4/AddDemandePVCL'));
const DemandePVCL = React.lazy(() => import('pages/Certifications/CF4/AddDemandePVCL/pvcl'));
const CF12 = React.lazy(() => import('pages/Certifications/CF12'));
const AddAnnexesCLP = React.lazy(() =>
  import('pages/Certifications/CF12/AddAnnexesCLP')
);
const AddCLP = React.lazy(() => import('pages/Certifications/CF12/AddCLP'));
const PVRDC = React.lazy(() => import('pages/Certifications/CF3/PVRDC'));
const ListePVRDC = React.lazy(() =>
  import('pages/Certifications/CF3/ListePVRDC')
);
const FicheDemographiqueCF = React.lazy(() =>
  import('pages/Certifications/CF3/FicheDemographiqueCF')
);
const AutresDeclarationsCF = React.lazy(() =>
  import(
    'pages/Certifications/CF3/DeclarationPrsAuditionneesCF/AutresDeclarationsCF'
  )
);
const InfoOccupantsParcelle = React.lazy(() =>
  import('pages/Certifications/CF3/InfoOccupantsParcelle')
);
const QuestionnaireCF = React.lazy(() =>
  import('pages/Certifications/CF3/QuestionnaireCF')
);
const CF1 = React.lazy(() => import('pages/Certifications/CF1'));
const PSFCPAMOFOREnqPromoContratenqueteCreee = React.lazy(() =>
  import('pages/Enquete/PSFCPAMOFOREnqPromoContratenqueteCreee')
);
const PSFCPAMOFOREnqPromoContratenqueteListPrefecture = React.lazy(() =>
  import('pages/Enquete/PSFCPAMOFOREnqPromoContratenqueteListPrefecture')
);
const PSFCPAMOFORcreerEnqute = React.lazy(() =>
  import('pages/Enquete/PSFCPAMOFORcreerEnqute')
);
const PSFCProfil = React.lazy(() => import('pages/Connexion/PSFCProfil'));
const PSFCMenuprofil = React.lazy(() =>
  import('pages/Connexion/PSFCMenuprofil')
);

const PSFCPAMOFOREnqPromoContratContratdonationpTenUpdate = React.lazy(() =>
  import('pages/Contrats/PSFCPAMOFOREnqPromoContratContratdonationpTen/update')
);
const PSFCPAMOFOREnqPromoContratContratdonationpTen = React.lazy(() =>
  import('pages/Contrats/PSFCPAMOFOREnqPromoContratContratdonationpTen')
);
const PSFCPAMOFOREnqPromoContratContratdonationpNineUpdate = React.lazy(() =>
  import('pages/Contrats/PSFCPAMOFOREnqPromoContratContratdonationpNine/update')
);
const PSFCPAMOFOREnqPromoContratContratdonationpNine = React.lazy(() =>
  import('pages/Contrats/PSFCPAMOFOREnqPromoContratContratdonationpNine')
);
const PSFCPAMOFOREnqPromoContratContratdonationpEightUpdate = React.lazy(() =>
  import(
    'pages/Contrats/PSFCPAMOFOREnqPromoContratContratdonationpEight/update'
  )
);
const PSFCPAMOFOREnqPromoContratContratdonationpEight = React.lazy(() =>
  import('pages/Contrats/PSFCPAMOFOREnqPromoContratContratdonationpEight')
);
const PSFCPAMOFOREnqPromoContratContratdonationpSevenUpdate = React.lazy(() =>
  import(
    'pages/Contrats/PSFCPAMOFOREnqPromoContratContratdonationpSeven/update'
  )
);
const PSFCPAMOFOREnqPromoContratContratdonationpSeven = React.lazy(() =>
  import('pages/Contrats/PSFCPAMOFOREnqPromoContratContratdonationpSeven')
);
const PSFCPAMOFOREnqPromoContratContratdonationpSixUpdate = React.lazy(() =>
  import('pages/Contrats/PSFCPAMOFOREnqPromoContratContratdonationpSix/update')
);
const PSFCPAMOFOREnqPromoContratContratdonationpSix = React.lazy(() =>
  import('pages/Contrats/PSFCPAMOFOREnqPromoContratContratdonationpSix')
);
const PSFCPAMOFOREnqPromoContratContratdonationpFiveUpdate = React.lazy(() =>
  import('pages/Contrats/PSFCPAMOFOREnqPromoContratContratdonationpFive/update')
);
const PSFCPAMOFOREnqPromoContratContratdonationpFive = React.lazy(() =>
  import('pages/Contrats/PSFCPAMOFOREnqPromoContratContratdonationpFive')
);
const PSFCPAMOFOREnqPromoContratContratdonationpFourUpdate = React.lazy(() =>
  import('pages/Contrats/PSFCPAMOFOREnqPromoContratContratdonationpFour/update')
);
const PSFCPAMOFOREnqPromoContratContratdonationpFour = React.lazy(() =>
  import('pages/Contrats/PSFCPAMOFOREnqPromoContratContratdonationpFour')
);
const PSFCPAMOFOREnqPromoContratContratdonationpThreeUpdate = React.lazy(() =>
  import(
    'pages/Contrats/PSFCPAMOFOREnqPromoContratContratdonationpThree/update'
  )
);
const PSFCPAMOFOREnqPromoContratContratdonationpThree = React.lazy(() =>
  import('pages/Contrats/PSFCPAMOFOREnqPromoContratContratdonationpThree')
);
const PSFCPAMOFOREnqPromoContratContratdonationpTwo = React.lazy(() =>
  import('pages/Contrats/PSFCPAMOFOREnqPromoContratContratdonationpTwo')
);
const PSFCPAMOFOREnqPromoContratContratdonationpTwoUpdate = React.lazy(() =>
  import('pages/Contrats/PSFCPAMOFOREnqPromoContratContratdonationpTwo/update')
);
const Addcontratone = React.lazy(() => import('pages/Contrats/Addcontratone'));
const Addcontratoneupdate = React.lazy(() =>
  import('pages/Contrats/Addcontratone/update')
);

const listeAnnexesContrat = React.lazy(() =>
  import('pages/Contrats/PSFCPAMOFORListeAnnexesContrat')
);
const PSFCPAMOFOREnqPromoContrataddContrat = React.lazy(() =>
  import('pages/Contrats/PSFCPAMOFOREnqPromoContrataddContrat')
);
const PSFCPAMOFOREnqPromoContratUpdateContrat = React.lazy(() =>
  import('pages/Contrats/PSFCPAMOFOREnqPromoContrataddContrat/update')
);
const PSFCPAMOFOREnqPromoContrat = React.lazy(() =>
  import('pages/Contrats/PSFCPAMOFOREnqPromoContrat')
);
const PSFCPAMOFOR = React.lazy(() => import('pages/Enquete/PSFCPAMOFOR'));
const PSFCProjets = React.lazy(() => import('pages/PSFCProjets'));
const ServicesDemande = React.lazy(() => import('pages/NosServices/demandes'));
const FUProjets = React.lazy(() => import('pages/FUProjets'));
const OtherProjets = React.lazy(() => import('pages/OtherProjets'));
const Projets = React.lazy(() => import('pages/Projets'));
const PSFCReinitialisermdp = React.lazy(() =>
  import('pages/Connexion/PSFCReinitialisermdp')
);
const PSFCMdpoublie = React.lazy(() => import('pages/Connexion/PSFCMdpoublie'));
const PSFCSeconnecter = React.lazy(() =>
  import('pages/Connexion/PSFCSeconnecter')
);
const PSFCSignin = React.lazy(() => import('pages/Connexion/PSFCSignin'));
const PSFCHome = React.lazy(() => import('pages/PSFCHome'));
const Client = React.lazy(() => import('pages/Client'));
const ClientStep1 = React.lazy(() => import('pages/Client/step1.jsx'));
const ClientStep2 = React.lazy(() => import('pages/Client/step2.jsx'));
const ClientStep3 = React.lazy(() => import('pages/Client/step3.jsx'));
const ClientStep4 = React.lazy(() => import('pages/Client/step4.jsx'));
const ExpertHome = React.lazy(() => import('pages/ExpertHome/homeExpert'));
const Contract = React.lazy(() => import('pages/Admin/AdminHomePage'));
const Certificat = React.lazy(() => import('pages/Admin/AdminHomePage'));
const Setting = React.lazy(() => import('pages/Admin/AdminHomePage'));
const Notification = React.lazy(() => import('pages/Admin/AdminHomePage'));
const Corbeille = React.lazy(() => import('pages/Admin/AdminHomePage'));
const Ota = React.lazy(() => import('pages/Admin/AdminHomePage'));

const Contact = React.lazy(() => import('pages/PSFCContact'));



const PSFCPAMOFORmodelepagevalidationcontratspageValidationSix = React.lazy(
  () =>
    import(
      'pages/Validations/PSFCPAMOFORmodelepagevalidationcontratspageValidationSix'
    )
);
const PSFCPAMOFORmodelepagevalidationcontratspageValidation1 = React.lazy(() =>
  import(
    'pages/Validations/PSFCPAMOFORmodelepagevalidationcontratspageValidation1'
  )
);
const PSFCPAMOFORmodelepagevalidationcontratspageValidationOne1 = React.lazy(
  () =>
    import(
      'pages/Validations/PSFCPAMOFORmodelepagevalidationcontratspageValidationOne1'
    )
);
const PSFCPAMOFORmodelepagevalidationcontratspageValidationFour1 = React.lazy(
  () =>
    import(
      'pages/Validations/PSFCPAMOFORmodelepagevalidationcontratspageValidationFour1'
    )
);
const PSFCPAMOFORmodelepagevalidationcontratspageValidationFour = React.lazy(
  () =>
    import(
      'pages/Validations/PSFCPAMOFORmodelepagevalidationcontratspageValidationFour'
    )
);
const PSFCPAMOFORmodelepagevalidationcontratspageValidationThree = React.lazy(
  () =>
    import(
      'pages/Validations/PSFCPAMOFORmodelepagevalidationcontratspageValidationThree'
    )
);
const PSFCPAMOFORmodelepagevalidationcontratspageValidationTwo = React.lazy(
  () =>
    import(
      'pages/Validations/PSFCPAMOFORmodelepagevalidationcontratspageValidationTwo'
    )
);
const PSFCPAMOFORmodelepagevalidationcontratspageValidationFive = React.lazy(
  () =>
    import(
      'pages/Validations/PSFCPAMOFORmodelepagevalidationcontratspageValidationFive'
    )
);
const PSFCPAMOFORmodelepagevalidationcontratsRejetCGEDS = React.lazy(() =>
  import('pages/Validations/PSFCPAMOFORmodelepagevalidationcontratsRejetCGEDS')
);
const PSFCPAMOFORmodelepagevalidationcontratspageValidationOne = React.lazy(
  () =>
    import(
      'pages/Validations/PSFCPAMOFORmodelepagevalidationcontratspageValidationOne'
    )
);

const PageCloturePubEnqueteDtv = React.lazy(() =>
  import('pages/Delimitations/CloturePubEnqueteDtv')
);

const DTVAddHistoriqueConstitution = React.lazy(() =>
  import('pages/Delimitations/HistoriqueDeConstitution')
);

const DTVAddConstatLimiteTroncon = React.lazy(() =>
  import('pages/Delimitations/ConstatLimiteTroncon/index')
);

const DTVAddConstatLimiteTronconCreate = React.lazy(() =>
  import('pages/Delimitations/ConstatLimiteTroncon/create/index')
);

const DTVAddRapportActivites = React.lazy(() =>
  import('pages/Delimitations/RapportActivites/index')
);

const DTVAddRapportActivitesCreate = React.lazy(() =>
  import('pages/Delimitations/RapportActivites/create/index')
);

const DTVAddScanDocument = React.lazy(() =>
  import('pages/Delimitations/ScanDocument/index')
);

const DTVAddScanDocumentCreate = React.lazy(() =>
  import('pages/Delimitations/ScanDocument/create/index')
);


const DTVOuverturePublicite = React.lazy(() =>
  import('pages/Delimitations/OuverturePublicite')
);

const DTVAnnoncePublicite = React.lazy(() =>
  import('pages/Delimitations/AnnoncePublicite')
);

const DTVAddHistoriqueConstitutionListePresence = React.lazy(() =>
  import('pages/Delimitations/HistoriqueDeConstitution/add-liste-presence')
);

const DTVAddOuverturePubliciteListePresence = React.lazy(() =>
  import('pages/Delimitations/OuverturePublicite/add-liste-presence')
);

const DTVAttestationApprobationEnquete = React.lazy(() =>
  import('pages/Delimitations/AttestationApprobationEnquete')
);

const PSFCPAMOFORlivrablesIngenieurieSociauxCahiersIntentionsCF = React.lazy(
  () =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/Cahiers-intentions/Certificat-foncier/index'
    )
);

const PSFCPAMOFORlivrablesIngenieurieSociauxCahiersIntentionsContrat =
  React.lazy(() =>
    import('pages/IngenieurieSociauxFonciere/ISFPrealable/Cahiers-intentions/Contrat/index')
  );

const PSFCPAMOFORlivrablesIngenieurieSociauxDeclarationOuvertureOperations =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/Declaration-ouverture-operation/index'
    )
  );

const PSFCPAMOFORlivrablesIngenieurieSociauxDeclarationOuvertureOperationsSousPrefecture =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/SousPrefecture/Declaration-ouverture-operation/index'
    )
  );

const PSFCPAMOFORlivrablesIngenieurieSociauxSousPrefectureListeDeclaration =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/SousPrefecture/Declaration-ouverture-operation/list-declaration'
    )
  );

const PSFCPAMOFORlivrablesIngenieurieCourrierTransSociauxSousPrefecture =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/SousPrefecture/CourrierTransmission/index'
    )
  );

const PSFCPAMOFORlivrablesIngenieurieSociauxReglementInterieurCvgfr =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/FormationMembreCVGFR/ReglementInterieurCvgfr/index'
    )
  );

const PSFCPAMOFORlivrablesIngenieurieSociauxRapportSurLeDeroulementDesActivités =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/RapportSurLeDeroulementDesActivités/index'
    )
  );

  const PSFCPAMOFORlivrablesIngenieurieSociauxFonciereActivitesDeFacilitation =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFComplementaire/ActivitesDeFacilitation/index'
    )
  );
  const PSFCPAMOFORlivrablesIngenieurieSociauxFonciereFormationEncadrement =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFComplementaire/FormationEncadrement/index'
    )
  );



const PSFCPAMOFORlivrablesIngenieurieSociauxReunionPeriodiqueDecisionSousPrefectorale =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/ReunionPeriodriqueComiteSousPrefectoralIgnierieSocioFonciere/ReunionPeriodiqueDecisionSousPrefectorale/index'
    )
  );

const PSFCPAMOFORlivrablesIngenieurieSociauxReunionPeriodiqueSousPrefectorale =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/SousPrefecture/Resume-resolution/index'
    )
  );

const PSFCPAMOFORlivrablesIngenieurieSociauxReunionPeriodiqueDecisionSousPrefectoraleSousPrefectureCreate =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/SousPrefecture/ReunionPeriodiqueDecisionSousPrefectorale/create/index'
    )
  );

const PSFCPAMOFORlivrablesIngenieurieSociauxReunionPeriodiqueDecisionSousPrefectoraleSousPrefecture =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/SousPrefecture/ReunionPeriodiqueDecisionSousPrefectorale/index'
    )
  );

const PSFCPAMOFORPresforListePresenceFormationCvgfr = React.lazy(() =>
  import(
    'pages/IngenieurieSociauxFonciere/ISFPrealable/FormationMembreCVGFR/PresforListePresenceFormationCvgfr/index'
  )
);

const PSFCPAMOFORlivrablesIngenieurieSociauxCalendrierOuverture = React.lazy(
  () =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/PriseDeContact/Calendrier-ceremonie-ouverture/index'
    )
);
const PSFCPAMOFORlivrablesIngenieurieSociauxPriseDeContactCompteRendu =
  React.lazy(() =>
    import('pages/IngenieurieSociauxFonciere/ISFPrealable/PriseDeContact/CompteRendu/index')
  );

const PSFCPAMOFORlivrablesIngenieurieSociauxPriseDeContactListeDePresence =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/PriseDeContact/ListeDePresence/index'
    )
  );

const PSFCPAMOFORlivrablesIngenieurieSociauxPriseDeContactRecueilDonneesPersonnelles =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/PriseDeContact/RecueilDonneesPersonnelles/index'
    )
  );

const PSFCPAMOFORlivrablesIngenieurieSociauxPriseDeContactRecueilDonneesPersonnellesSousPrefecture =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/SousPrefecture/RecueilDonneePersonnel/list-recueil'
    )
  );

const PSFCPAMOFORlivrablesIngenieurieSociauxPriseDeContactRecueilDonneesPersonnellesSousPrefectureCreate =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/SousPrefecture/RecueilDonneePersonnel/create'
    )
  );

const PSFCPAMOFORlivrablesIngenieurieSociauxCeremonieOuverture = React.lazy(
  () =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/Ceremonie-ouverture/Model-propose-ceremonie-ouverture/index'
    )
);

const PSFCPAMOFORlivrablesIngenieurieSociauxCompteRendu = React.lazy(() =>
  import(
    'pages/IngenieurieSociauxFonciere/ISFPrealable/Ceremonie-ouverture/Model-propose-compte-rendu/index'
  )
);

const PSFCPAMOFORlivrablesIngenieurieSociauxRapportIsfVillage = React.lazy(() =>
  import(
    'pages/IngenieurieSociauxFonciere/ISFPrealable/Ceremonie-ouverture/Rapport-isf-village/index'
  )
);

const PSFCPAMOFORlivrablesIngenieurieReunionComiteSousPrefectoral = React.lazy(
  () =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/ReunionComiteSousPrefectoral/index'
    )
);
const PSFCPAMOFORlivrablesIngenieurieSociauxCalendrierPrevisionnelActivites =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/ActivitesDialogueRenforceMemorandum/CalendrierPrevisionnelActivites/index'
    )
  );
const PSFCPAMOFORlivrablesIngenieurieSociauxCharteRelationTuteurPlanteur =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/ActivitesDialogueRenforceMemorandum/CharteRelationTuteurPlanteur/index'
    )
  );
const PSFCPAMOFORlivrablesIngenieurieSociauxGuideEntretienDiscussion =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/ActivitesDialogueRenforceMemorandum/GuideEntretienDiscussion/index'
    )
  );
const PSFCPAMOFORlivrablesIngenieurieSociauxMethodologieProtocoleGestion =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/ActivitesDialogueRenforceMemorandum/MethodologieProtocoleGestion/index'
    )
  );
const PSFCPAMOFORlivrablesIngenieurieSociauxProcesVerbalConstatAchevement =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/ActivitesDialogueRenforceMemorandum/ProcesVerbalConstatAchevement/index'
    )
  );

const PSFCPAMOFORlivrablesIngenieurieSociauxProcesVerbaleClarification =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/ActivitesDialogueRenforceMemorandum/ProcesVerbaleClarification/index'
    )
  );

const PSFCPAMOFORlivrablesIngenieurieSociauxProcesVerbaleClarificationCreate =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/ActivitesDialogueRenforceMemorandum/ProcesVerbaleClarification/create/index'
    )
  );

const PSFCPAMOFORlivrablesIngenieurieSociauxProcesVerbaleClarificationA =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/ActivitesDialogueRenforceMemorandum/ProcesVerbaleClarification/create/ProcesVerbaleClarificationA/index'
    )
  );
const PSFCPAMOFORlivrablesIngenieurieSociauxProcesVerbaleClarificationB =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/ActivitesDialogueRenforceMemorandum/ProcesVerbaleClarification/create/ProcesVerbaleClarificationB/index'
    )
  );

const PSFCPAMOFORlivrablesIngenieurieSociauxModeleProposeCourrierTransmission =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/ElaborationCalendrier/ModeleProposeCourrierTransmission/index'
    )
  );

const PSFCPAMOFORlivrablesIngenieurieSociauxCalendrierPrevisionnelPremiereActivite =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/ElaborationCalendrier/CalendrierPrevisionnelPremiereActivite/index'
    )
  );

const PSFCPAMOFORlivrablesIngenieurieSociauxProcesVerbaleClarificationC =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/ActivitesDialogueRenforceMemorandum/ProcesVerbaleClarification/create/ProcesVerbaleClarificationC/index'
    )
  );
const PSFCPAMOFORlivrablesIngenieurieSociauxProcesVerbalReglementLitige =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/ActivitesDialogueRenforceMemorandum/ProcesVerbalReglementLitige/index'
    )
  );
const PSFCPAMOFORlivrablesIngenieurieSociauxProcesVerbalReglementLitigeCreate =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/ActivitesDialogueRenforceMemorandum/ProcesVerbalReglementLitige/create/index'
    )
  );

const PSFCPAMOFORlivrablesIngenieurieSociauxRapportIsf = React.lazy(() =>
  import(
    'pages/IngenieurieSociauxFonciere/ISFPrealable/InformationSensibilisationActeursVillageois/rapport-isf'
  )
);

const PSFCPAMOFORlivrablesIngenieurieSociauxModelProposeListePresenceReunionInformationSensibilisation =
  React.lazy(() =>
    import(
      'pages/IngenieurieSociauxFonciere/ISFPrealable/InformationSensibilisationActeursVillageois/model-propose-liste-presence-reunion-information-sensibilisation'
    )
  );

const ProjectRoutes = () => {
  return (
    <React.Suspense fallback={<>Loading...</>}>
      <Router>
        <AppLayout>
          <Routes>
            <Route
              path="/dtv/historique-constitution"
              element={
                <ProtectedRoute element={DTVAddHistoriqueConstitution} />
              }
            />
            <Route
              path="/dtv/ouverture-publicite"
              element={<ProtectedRoute element={DTVOuverturePublicite} />}
            />

            <Route
              path="/dtv/annonce-publicite"
              element={<ProtectedRoute element={DTVAnnoncePublicite} />}
            />

            {/* <Route
              path="/dtv/decision-sous-prefectoral"
              element={
                <ProtectedRoute
                  element={PSFCPAMOFORlivrablesIngenieurieSociauxDecisionSousPrefectoral}
                />
              }
            /> */}

            <Route
              path="/dtv/ouverture-publicite/liste-presence"
              element={
                <ProtectedRoute
                  element={DTVAddOuverturePubliciteListePresence}
                />
              }
            />

            <Route
              path="/dtv/historique-constitution-liste"
              element={
                <ProtectedRoute
                  element={DTVAddHistoriqueConstitutionListePresence}
                />
              }
            />

            <Route
              path="/dtv/constat-limite-troncon"
              element={<ProtectedRoute element={DTVAddConstatLimiteTroncon} />}
            />

            <Route
              path="/dtv/constat-limite-troncon/create"
              //path="/attestation-approbation-enquete"
              element={
                <ProtectedRoute element={DTVAddConstatLimiteTronconCreate} />
              }
            />

            <Route
              path="/dtv/rapport-activites"
              element={<ProtectedRoute element={DTVAddRapportActivites} />}
            />

            <Route
              path="/dtv/rapport-activites/create"
              //path="/attestation-approbation-enquete"
              element={
                <ProtectedRoute element={DTVAddRapportActivitesCreate} />
              }
            />

            <Route
              path="/dtv/scan-document"
              element={<ProtectedRoute element={DTVAddScanDocument} />}
            />

            <Route
              path="/dtv/scan-document/create"
              element={
                <ProtectedRoute element={DTVAddScanDocumentCreate} />
              }
            />

            

            <Route
              path="/attestation-approbation-enquete"
              element={
                <ProtectedRoute element={DTVAttestationApprobationEnquete} />
              }
            />

            {/* <Route
              path="/attestation-validation-enquete-fonciere"
              element={<AttestationValidationEnqueteFonciere />}
            /> */}

            <Route
              path="/attestation-validation-enquete-fonciere"
              element={<PageAttestationValidationEnqueteFonciere />}
            />
            <Route
              path="/cloture-pub-enquete-dtv"
              element={<PageCloturePubEnqueteDtv />}
            />

            <Route path="/" element={<PSFCHome />} />
            <Route path="/client" element={<Client />} />
            <Route path="/ClientStep1" element={<ClientStep1 />} />
            <Route path="/ClientStep2" element={<ClientStep2 />} />
            <Route path="/ClientStep3" element={<ClientStep3 />} />
            <Route path="/ClientStep4" element={<ClientStep4 />} />
            <Route path="/accueil-expert" element={<ExpertHome />} />
            <Route path="*" element={<NotFound />} />

            <Route
              path="/psfcpamoformodelepagevalidationcontratspagevalidationone"
              element={
                <PSFCPAMOFORmodelepagevalidationcontratspageValidationOne />
              }
            />
            <Route
              path="/psfcpamoformodelepagevalidationcontratsrejetcgeds"
              element={<PSFCPAMOFORmodelepagevalidationcontratsRejetCGEDS />}
            />
            <Route
              path="/psfcpamoformodelepagevalidationcontratspagevalidationfive"
              element={
                <PSFCPAMOFORmodelepagevalidationcontratspageValidationFive />
              }
            />
            <Route
              path="/psfcpamoformodelepagevalidationcontratspagevalidationtwo"
              element={
                <PSFCPAMOFORmodelepagevalidationcontratspageValidationTwo />
              }
            />
            <Route
              path="/psfcpamoformodelepagevalidationcontratspagevalidationthree"
              element={
                <PSFCPAMOFORmodelepagevalidationcontratspageValidationThree />
              }
            />
            <Route
              path="/psfcpamoformodelepagevalidationcontratspagevalidationfour"
              element={
                <PSFCPAMOFORmodelepagevalidationcontratspageValidationFour />
              }
            />
            <Route
              path="/psfcpamoformodelepagevalidationcontratspagevalidationfour1"
              element={
                <PSFCPAMOFORmodelepagevalidationcontratspageValidationFour1 />
              }
            />
            <Route
              path="/psfcpamoformodelepagevalidationcontratspagevalidationthree"
              element={
                <PSFCPAMOFORmodelepagevalidationcontratspageValidationThree />
              }
            />
            <Route
              path="/psfcpamoformodelepagevalidationcontratspagevalidationone1"
              element={
                <PSFCPAMOFORmodelepagevalidationcontratspageValidationOne1 />
              }
            />
            <Route
              path="/psfcpamoformodelepagevalidationcontratspagevalidation1"
              element={
                <PSFCPAMOFORmodelepagevalidationcontratspageValidation1 />
              }
            />
            <Route
              path="/psfcpamoformodelepagevalidationcontratspagevalidationsix"
              element={
                <PSFCPAMOFORmodelepagevalidationcontratspageValidationSix />
              }
            />

            <Route path="/contact" element={<Contact />} />

            <Route path="/AdminHomePage" element={<AdminHomePage />}>
              <Route path="user" element={<User />} />
              <Route path="ota" element={<Ota />} />
              <Route path="contract" element={<Contract />} />
              <Route path="certificat" element={<Certificat />} />
              <Route path="setting" element={<Setting />} />
              <Route path="notification" element={<Notification />} />
              <Route path="corbeille" element={<Corbeille />} />
            </Route>

             <Route path="/AdminPresforPage" element={<AdminPresforPage />}>
              <Route path="user" element={<UserPresfor />} />
              <Route path="ota" element={<OtaPresfor />} />
              <Route path="isf-prealable" element={<IsfPrealable />} />
              <Route path="isf-complementaire" element={<IsfComplementaire />} />
              <Route path="dtv" element={<Dtv />} />
              <Route path="contract" element={<ContractPresfor />} />
              <Route path="certificat" element={<CertificatPresfor />} />
              <Route path="setting" element={<SettingPresfor />} />
              <Route path="notification" element={<NotificationPresfor />} />
              <Route path="corbeille" element={<CorbeillePresfor />} />
            </Route>

            <Route
              path="/resumecontrat"
              element={<ProtectedRoute element={Resumecontrat} />}
            />

            <Route
              path="/error"
              element={<ProtectedRoute element={ErrorBoundary} />}
            />

            <Route path="/psfcsignin" element={<PSFCSignin />} />
            <Route path="/psfcseconnecter" element={<PSFCSeconnecter />} />
            <Route path="/psfcmdpoublie" element={<PSFCMdpoublie />} />
            <Route
              path="/psfcreinitialisermdp"
              element={<PSFCReinitialisermdp />}
            />
            <Route path="/psfcmenuprofil" element={<PSFCMenuprofil />} />
            <Route path="/psfcprofil" element={<PSFCProfil />} />
            <Route
              path="/psfcpamoforcreerenqute"
              element={<ProtectedRoute element={PSFCPAMOFORcreerEnqute} />}
            />
            <Route
              path="/psfcpamoforenqpromocontratenquetecreee"
              element={
                <ProtectedRoute
                  element={PSFCPAMOFOREnqPromoContratenqueteCreee}
                />
              }
            />
            <Route
              path="/psfcpamoforenqpromocontratenquetecreee/prefecture"
              element={
                <ProtectedRoute
                  element={PSFCPAMOFOREnqPromoContratenqueteListPrefecture}
                />
              }
            />
            <Route
              path="/psfcprojets"
              element={<ProtectedRoute element={PSFCProjets} />}
            />
            <Route
              path="/foncierurbaineprojets"
              element={<ProtectedRoute element={FUProjets} />}
            />
            <Route
              path="/autresprojets"
              element={<ProtectedRoute element={OtherProjets} />}
            />

            <Route
              path="/projets"
              element={<ProtectedRoute element={Projets} />}
            />
            <Route
              path="/service/demande"
              element={<ProtectedRoute element={ServicesDemande} />}
            />

            <Route
              path="/psfcpresfor"
              element={<ProtectedRoute element={PSFCPAMOFOR} />}
            />

            <Route
              path="/psfcpamoforlivrablesIngenieurieSociaux"
              element={
                <ProtectedRoute
                  element={PSFCPAMOFORlivrablesIngenieurieSociaux}
                />
              }
            />

            <Route
              path="/psfcpamoforlivrablesIngenieurieSociauxSousPrefecture"
              element={
                <ProtectedRoute
                  element={PSFCPAMOFORlivrablesIngenieurieSociauxSousPrefecture}
                />
              }
            />

            <Route
              path="/psfcpamoforlivrablessensiblisation"
              element={
                <ProtectedRoute element={PSFCPAMOFORLivrablesSensibilisation} />
              }
            />

            <Route
              path="/psfcpamoforlivrablescloture"
              element={<ProtectedRoute element={PSFCPAMOFORLivrablesCloture} />}
            />

            <Route
              path="/psfcpamoforlivrablesdelimitation"
              element={
                <ProtectedRoute element={PSFCPAMOFORLivrablesDelimitation} />
              }
            />

            <Route
              path="/model-propose-ceremonie-ouverture"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxCeremonieOuverture
                  }
                />
              }
            />

            <Route
              path="/model-propose-courrier-transmission"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxModeleProposeCourrierTransmission
                  }
                />
              }
            />

            <Route
              path="/calendrier-previsionnel-premiere-activite"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxCalendrierPrevisionnelPremiereActivite
                  }
                />
              }
            />

            <Route
              path="/calendrier-ceremonie-ouverture"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxCalendrierOuverture
                  }
                />
              }
            />
            <Route
              path="/compte-rendu-de-prise-de-contact"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxPriseDeContactCompteRendu
                  }
                />
              }
            />
            <Route
              path="/liste-de-presence-de-prise-de-contact"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxPriseDeContactListeDePresence
                  }
                />
              }
            />

            <Route
              path="/recueil-donnees-personnelles"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxPriseDeContactRecueilDonneesPersonnelles
                  }
                />
              }
            />

            <Route
              path="/recueil-donnees-personnelles/sous-prefecture"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxPriseDeContactRecueilDonneesPersonnellesSousPrefecture
                  }
                />
              }
            />

            <Route
              path="/recueil-donnees-personnelles/sous-prefecture/create"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxPriseDeContactRecueilDonneesPersonnellesSousPrefectureCreate
                  }
                />
              }
            />

            <Route
              path="/model-propose-compte-rendu"
              element={
                <ProtectedRoute
                  element={PSFCPAMOFORlivrablesIngenieurieSociauxCompteRendu}
                />
              }
            />
            <Route
              path="/decision-creation-cvgfr"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxDecisionCreation
                  }
                />
              }
            />
            <Route
              path="/reunion-periodique-decision-sous-prefectorale"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxReunionPeriodiqueDecisionSousPrefectorale
                  }
                />
              }
            />

            <Route
              path="/reunion-periodique-decision-sous-prefectorale/sous-prefecture/create"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxReunionPeriodiqueDecisionSousPrefectoraleSousPrefectureCreate
                  }
                />
              }
            />

            <Route
              path="/reunion-periodique-decision-sous-prefectorale/sous-prefecture"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxReunionPeriodiqueDecisionSousPrefectoraleSousPrefecture
                  }
                />
              }
            />

            <Route
              path="/reunion-periodique-sous-prefectorale/sous-prefecture"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxReunionPeriodiqueSousPrefectorale
                  }
                />
              }
            />

            <Route
              path="/decision-sous-prefectorale"
              element={
                <ProtectedRoute
                  element={PSFCPRESFORISFDesignationActivitesDialogueSocial}
                />
              }
            />

            <Route
              path="/resolutions-des-reunions-cspisf"
              element={
                <ProtectedRoute
                  element={PSFCPRESFORISFResolutionsdesReunionsCSPISF}
                />
              }
            />

            <Route
              path="/proces-verbal-cvgfr"
              element={
                <ProtectedRoute
                  element={PSFCPAMOFORlivrablesIngenieurieSociauxProcesVerbal}
                />
              }
            />

            <Route
              path="/rapport-sur-le-deroulement-des-activites"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxRapportSurLeDeroulementDesActivités
                  }
                />
              }
            />

            <Route
              path="/attestation-formation-cvgfr"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxAttestationFormationCvgfr
                  }
                />
              }
            />

            <Route
              path="/livrable-cvgfr"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxDiagnosticCvgfrLivrable
                  }
                />
              }
            />

            <Route
              path="/cahiers-intentions-cf"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxCahiersIntentionsCF
                  }
                />
              }
            />

            <Route
              path="/cahiers-intentions-contrat"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxCahiersIntentionsContrat
                  }
                />
              }
            />

            <Route
              path="/psfcpamoforconsolidationdispositifs"
              element={
                <ProtectedRoute element={PSFCPAMOFORLivrablesConsolidation} />
              }
            />

            <Route
              path="/psfcpamoforconsolidationdroits"
              element={
                <ProtectedRoute
                  element={PSFCPAMOFORLivrablesConsolidationDroits}
                />
              }
            />

            <Route
              path="/consodispo/attestationformationaefj"
              element={
                <ProtectedRoute
                  element={ConsolidationAttestationFormationAEFJ}
                />
              }
            />

            <Route
              path="/consodispo/attestationformationaefc"
              element={
                <ProtectedRoute
                  element={ConsolidationAttestationFormationAEFC}
                />
              }
            />

            <Route
              path="/psfcpamoforenqpromocontrat"
              element={<ProtectedRoute element={PSFCPAMOFOREnqPromoContrat} />}
            />
            <Route
              path="/psfcpamoforenqpromocontrataddcontrat"
              element={
                <ProtectedRoute
                  element={PSFCPAMOFOREnqPromoContrataddContrat}
                />
              }
            />

            <Route
              path="/psfcpamoforenqpromocontratupdatecontrat"
              element={
                <ProtectedRoute
                  element={PSFCPAMOFOREnqPromoContratUpdateContrat}
                />
              }
            />
            <Route
              path="/psfcpamoforlivrablescf"
              element={<ProtectedRoute element={PSFCPAMOFORlivrablescf} />}
            />

            <Route
              path="/psfcpamoforenqcf"
              element={<ProtectedRoute element={PSFCPAMOFORENQCF} />}
            />
            <Route path="/addcf" element={<ProtectedRoute element={AddCF} />} />
            <Route
              path="/editcf"
              element={<ProtectedRoute element={EditCF} />}
            />
            <Route
              path="/addficheidentification"
              element={<ProtectedRoute element={AddFicheIdentification} />}
            />
            {
              <Route
                path="/addcfinfo"
                element={<ProtectedRoute element={AddCFInfo} />}
              />
            }
            <Route
              path="/demandeenqcf"
              element={<ProtectedRoute element={DemandeEnqCF} />}
            />
            <Route
              path="/infooptcf"
              element={<ProtectedRoute element={InfoOPTCF} />}
            />
            <Route
              path="/FicheLitigesCF"
              element={<ProtectedRoute element={FicheLitigesCF} />}
            />
            <Route
              path="/EtatDesDroitsDeProp"
              element={<ProtectedRoute element={EtatDesDroitsDeProp} />}
            />
            <Route
              path="/ListeDetenteursDeDroitsCF"
              element={<ProtectedRoute element={ListeDetenteursDeDroitsCF} />}
            />
            <Route
              path="/ListeDesServitudes"
              element={<ProtectedRoute element={ListeDesServitudes} />}
            />
            <Route path="/pub" element={<ProtectedRoute element={PUB} />} />
            <Route
              path="/addannexesouverturepub"
              element={<ProtectedRoute element={AddAnnexesOuverturePub} />}
            />
            <Route
              path="/addouverturepub"
              element={<ProtectedRoute element={AddOuverturePub} />}
            />
            <Route
              path="/addenqueteouverturepub"
              element={<ProtectedRoute element={AddEnqueteOuverturePub} />}
            />
            <Route
              path="/addannexespvpub"
              element={<ProtectedRoute element={AddAnnexesPVPub} />}
            />
            <Route
              path="/addpvpub"
              element={<ProtectedRoute element={AddPVPub} />}
            />
            <Route
              path="/addcf19"
              element={<ProtectedRoute element={AddCf19} />}
            />
            <Route
              path="/addannexesannoncepub"
              element={<ProtectedRoute element={AddAnnexesAnnoncePub} />}
            />
            <Route
              path="/addannoncepub"
              element={<ProtectedRoute element={AddAnnoncePub} />}
            />
            <Route
              path="/ListeDesAyantsDroitsCF"
              element={<ProtectedRoute element={ListeDesAyantsDroitsCF} />}
            />
            <Route
              path="/GestionnaireCF"
              element={<ProtectedRoute element={GestionnaireCF} />}
            />
            <Route
              path="/updateGestionnaireCF"
              element={<ProtectedRoute element={UpdateGestionnaireCF} />}
            />
            <Route
              path="/uodateGestionnaireCF"
              element={<ProtectedRoute element={UpdateGestionnaireCF} />}
            />
            <Route
              path="/addannexesvalidation"
              element={<ProtectedRoute element={AddAnnexesValidation} />}
            />
            <Route
              path="/addvalidation"
              element={<ProtectedRoute element={AddValidation} />}
            />
            <Route
              path="/addannexescecpdc"
              element={<ProtectedRoute element={AddAnnexesCECPDC} />}
            />
            <Route
              path="/addcecpdc"
              element={<ProtectedRoute element={AddCECPDC} />}
            />
            <Route
              path="/updateGestionnaireCF"
              element={<ProtectedRoute element={UpdateGestionnaireCF} />}
            />
            <Route
              path="/SignatairesDesignationGestionnaire"
              element={
                <ProtectedRoute element={SignatairesDesignationGestionnaire} />
              }
            />
            <Route
              path="/GestionnaireCF"
              element={<ProtectedRoute element={GestionnaireCF} />}
            />
            <Route
              path="/pvrdcTemplate"
              element={<ProtectedRoute element={PVRDCTemplate} />}
            />
            <Route
              path="/addannexespvcl"
              element={<ProtectedRoute element={AddAnnexesPVCL} />}
            />
            <Route
              path="/pvcl-annexe"
              element={<ProtectedRoute element={AddDemandePVCLAnnexes} />}
            />
            <Route
              path="/addannexesclp"
              element={<ProtectedRoute element={AddAnnexesCLP} />}
            />
            <Route path="/cf4" element={<ProtectedRoute element={CF4} />} />
            <Route path="/cf8" element={<ProtectedRoute element={CF8} />} />
            <Route path="/cf9" element={<ProtectedRoute element={CF9} />} />
            <Route path="/cf10" element={<ProtectedRoute element={CF10} />} />
            <Route path="/cf11" element={<ProtectedRoute element={CF11} />} />
            <Route path="/cf12" element={<ProtectedRoute element={CF12} />} />
            <Route path="/cf19" element={<ProtectedRoute element={CF19} />} />
            <Route path="/cf20" element={<ProtectedRoute element={CF20} />} />
            <Route
              path="/addpvcl"
              element={<ProtectedRoute element={AddPVCL} />}
            />
             <Route
              path="/adddemandepvcl"
              element={<ProtectedRoute element={AddDemandePVCL} />}
            />
             <Route
              path="/demandepvcl"
              element={<ProtectedRoute element={DemandePVCL} />}
            />
            <Route
              path="/addclp"
              element={<ProtectedRoute element={AddCLP} />}
            />
            <Route path="/pvrdc" element={<ProtectedRoute element={PVRDC} />} />
            <Route
              path="/listepvrdc"
              element={<ProtectedRoute element={ListePVRDC} />}
            />
            <Route
              path="/fichedemographiquecf"
              element={<ProtectedRoute element={FicheDemographiqueCF} />}
            />
            <Route
              path="/AutresDeclarationsCF"
              element={<ProtectedRoute element={AutresDeclarationsCF} />}
            />
            <Route
              path="/InfoOccuppantsParcelle"
              element={<ProtectedRoute element={InfoOccupantsParcelle} />}
            />
            <Route
              path="/QuestionnaireCF"
              element={<ProtectedRoute element={QuestionnaireCF} />}
            />
            <Route
              path="/Addcontratone"
              element={<ProtectedRoute element={Addcontratone} />}
            />
            <Route
              path="/AddcontratoneUpdate"
              element={<ProtectedRoute element={Addcontratoneupdate} />}
            />
            <Route
              path="/psfcpamoforlisteannexescontrat"
              element={<ProtectedRoute element={listeAnnexesContrat} />}
            />
            <Route
              path="/psfcpamoforenqpromocontratcontratdonationptwo"
              element={
                <ProtectedRoute
                  element={PSFCPAMOFOREnqPromoContratContratdonationpTwo}
                />
              }
            />
            <Route
              path="/psfcpamoforenqpromocontratcontratdonationptwoupdate"
              element={
                <ProtectedRoute
                  element={PSFCPAMOFOREnqPromoContratContratdonationpTwoUpdate}
                />
              }
            />
            <Route
              path="/psfcpamoforenqpromocontratcontratdonationpthree"
              element={
                <ProtectedRoute
                  element={PSFCPAMOFOREnqPromoContratContratdonationpThree}
                />
              }
            />
            <Route
              path="/psfcpamoforenqpromocontratcontratdonationpthreeUpdate"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFOREnqPromoContratContratdonationpThreeUpdate
                  }
                />
              }
            />
            <Route
              path="/psfcpamoforenqpromocontratcontratdonationpfourupdate"
              element={
                <ProtectedRoute
                  element={PSFCPAMOFOREnqPromoContratContratdonationpFourUpdate}
                />
              }
            />
            <Route
              path="/psfcpamoforenqpromocontratcontratdonationpfour"
              element={
                <ProtectedRoute
                  element={PSFCPAMOFOREnqPromoContratContratdonationpFour}
                />
              }
            />
            <Route
              path="/psfcpamoforenqpromocontratcontratdonationpfive"
              element={
                <ProtectedRoute
                  element={PSFCPAMOFOREnqPromoContratContratdonationpFive}
                />
              }
            />
            <Route
              path="/psfcpamoforenqpromocontratcontratdonationpfiveupdate"
              element={
                <ProtectedRoute
                  element={PSFCPAMOFOREnqPromoContratContratdonationpFiveUpdate}
                />
              }
            />
            <Route
              path="/psfcpamoforenqpromocontratcontratdonationpsix"
              element={
                <ProtectedRoute
                  element={PSFCPAMOFOREnqPromoContratContratdonationpSix}
                />
              }
            />
            <Route
              path="/psfcpamoforenqpromocontratcontratdonationpsixupdate"
              element={
                <ProtectedRoute
                  element={PSFCPAMOFOREnqPromoContratContratdonationpSixUpdate}
                />
              }
            />
            <Route
              path="/psfcpamoforenqpromocontratcontratdonationpseven"
              element={
                <ProtectedRoute
                  element={PSFCPAMOFOREnqPromoContratContratdonationpSeven}
                />
              }
            />
            <Route
              path="/psfcpamoforenqpromocontratcontratdonationpsevenupdate"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFOREnqPromoContratContratdonationpSevenUpdate
                  }
                />
              }
            />
            <Route
              path="/psfcpamoforenqpromocontratcontratdonationpeight"
              element={
                <ProtectedRoute
                  element={PSFCPAMOFOREnqPromoContratContratdonationpEight}
                />
              }
            />
            <Route
              path="/psfcpamoforenqpromocontratcontratdonationpeightupdate"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFOREnqPromoContratContratdonationpEightUpdate
                  }
                />
              }
            />
            <Route
              path="/psfcpamoforenqpromocontratcontratdonationpnine"
              element={
                <ProtectedRoute
                  element={PSFCPAMOFOREnqPromoContratContratdonationpNine}
                />
              }
            />
            <Route
              path="/psfcpamoforenqpromocontratcontratdonationpnineupdate"
              element={
                <ProtectedRoute
                  element={PSFCPAMOFOREnqPromoContratContratdonationpNineUpdate}
                />
              }
            />
            <Route
              path="/psfcpamoforenqpromocontratcontratdonationpten"
              element={
                <ProtectedRoute
                  element={PSFCPAMOFOREnqPromoContratContratdonationpTen}
                />
              }
            />
            <Route
              path="/psfcpamoforenqpromocontratcontratdonationptenupdate"
              element={
                <ProtectedRoute
                  element={PSFCPAMOFOREnqPromoContratContratdonationpTenUpdate}
                />
              }
            />
            <Route
              path="/presfordeclarationouvertureoperation"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxDeclarationOuvertureOperations
                  }
                 
                />
              }
            />

            <Route
              path="/presfordeclarationouvertureoperation/sous-prefecture/liste-declaration"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxSousPrefectureListeDeclaration
                  }
                />
              }
            />

            <Route
              path="/presfordeclarationouvertureoperation/sous-prefecture"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxDeclarationOuvertureOperationsSousPrefecture
                  }
                />
              }
            />

            <Route
              path="/presforcourriertransmission/sous-prefecture"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieCourrierTransSociauxSousPrefecture
                  }
                />
              }
            />

            <Route
              path="/presforReglementInterieurCvgfr"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxReglementInterieurCvgfr
                  }
                />
              }
            />

            <Route
              path="/presforReunionPeriodiqueDecisionSousPrefectorale"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxReunionPeriodiqueDecisionSousPrefectorale
                  }
                />
              }
            />

            <Route
              path="/PresforListePresenceFormationCvgfr"
              element={
                <ProtectedRoute
                  element={PSFCPAMOFORPresforListePresenceFormationCvgfr}
                />
              }
            />

            <Route
              path="/presforRapportIsfVillage"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxRapportIsfVillage
                  }
                />
              }
            />

            <Route
              path="/calendrier-previsionnel-activites"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxCalendrierPrevisionnelActivites
                  }
                />
              }
            />
            <Route
              path="/charte-relation-tuteur-planteur"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxCharteRelationTuteurPlanteur
                  }
                />
              }
            />
            <Route
              path="/guide-entretien-discussion"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxGuideEntretienDiscussion
                  }
                />
              }
            />
            <Route
              path="/methodologie-protocole-gestion"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxMethodologieProtocoleGestion
                  }
                />
              }
            />
            <Route
              path="/proces-verbal-constat-achevement"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxProcesVerbalConstatAchevement
                  }
                />
              }
            />

            <Route
              path="/proces-verbale-clarification/create"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxProcesVerbaleClarificationCreate
                  }
                />
              }
            />

            <Route
              path="/proces-verbale-clarification"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxProcesVerbaleClarification
                  }
                />
              }
            />

            <Route
              path="/proces-verbale-clarification-a"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxProcesVerbaleClarificationA
                  }
                />
              }
            />
            <Route
              path="/proces-verbale-clarification-b"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxProcesVerbaleClarificationB
                  }
                />
              }
            />
            <Route
              path="/proces-verbale-clarification-c"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxProcesVerbaleClarificationC
                  }
                />
              }
            />
            <Route
              path="/proces-verbal-reglement-litige"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxProcesVerbalReglementLitige
                  }
                />
              }
            />
            <Route
              path="/proces-verbal-reglement-litige/create"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxProcesVerbalReglementLitigeCreate
                  }
                />
              }
            />
            <Route
              path="/PresforResolutionReunionsCspisf"
              element={
                <ProtectedRoute
                  element={PSFCPAMOFORLivrablespresforResolutionReunionsCspisf}
                />
              }
            />

            <Route
              path="/rapport-isf"
              element={
                <ProtectedRoute
                  element={PSFCPAMOFORlivrablesIngenieurieSociauxRapportIsf}
                />
              }
            />

            <Route
              path="/facilitation-formulaire-complementaire"
              element={
                <ProtectedRoute
                  element={PSFCPAMOFORlivrablesIngenieurieSociauxFonciereActivitesDeFacilitation}
                />
              }
            />
            <Route
              path="/isf-complementaire/formation-encadrement"
              element={
                <ProtectedRoute
                  element={PSFCPAMOFORlivrablesIngenieurieSociauxFonciereFormationEncadrement}
                />
              }
            />

            <Route
              path="/model-propose-liste-presence-reunion-information-sensibilisation"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxModelProposeListePresenceReunionInformationSensibilisation
                  }
                />
              }
            />
            <Route
              path="/PresforProceduresEtablissementEtatCivil"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablespresforProceduresEtablissementEtatCivil
                  }
                />
              }
            />
            <Route
              path="/PresforProceduresEtablissementEtatCivilCreate"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablespresforProceduresEtablissementEtatCivilCreate
                  }
                />
              }
            />
            <Route
              path="/EnqueteOrganisationSocioFonciere"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablespresforEnqueteOrganisationSocioFonciere
                  }
                />
              }
            />
            <Route
              path="/isf-complementaire/information-sensibilisation"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieSociauxInformationSensibilisation
                  }
                />
              }
            />
            

            <Route path="/cf1" element={<CF1 />} />
            <Route path="/dhiwise-dashboard" element={<Home />} />
            {/* <Route path="/dtv/constat-limite-troncon/edit/:id" element={<EditFormulaire />} /> */}
            <Route
              path="/reunion-comite-sous-prefectoral"
              element={
                <ProtectedRoute
                  element={
                    PSFCPAMOFORlivrablesIngenieurieReunionComiteSousPrefectoral
                  }
                />
              }
            />
          </Routes>
        </AppLayout>
      </Router>
    </React.Suspense>
  );
};
export default ProjectRoutes;
